function PanFrontViewRTDL(vars) {
  const getAngle = (p5, v1, v2) => +(Math.abs(degrees(Math.atan(
      (v1.y - v2.y) / (v1.x - v2.x),
  ))).toFixed(1));

  const { p5, backgroundPattern, state: {
    scale,
  } } = this;

  const {
    panWidth, panHeight, splashWallWidth,
    drainWidth, drainX, trenchFloorThickness,
    drainPlateWidth, grateStyle, depthDeclineTotal,
    drainPosition, grateThickness, drainDimensionWidth,
    curbWidth, curbHeight,
  } = vars;

  const { drainOpening } = panBaseSpec;
  const { toleranceRange } = specText;

  const {
    cornerLineLength, panLineMargin, sectionDimensionClearance,
  } = specConfig;

  const vLine = cornerLineLength / 4;
  const sectionDimensionOffset = panLineMargin + vLine + sectionDimensionClearance;
  const margin = 100;
  const padding = 10;
  const panFront = createGraphics(panWidth + margin, panHeight + margin);

  panFront.translate(padding, padding);
  panFront.fill(255);
  panFront.drawingContext.fillStyle = backgroundPattern;

  // Splash Wall Meet Floor
  const leftWallMeetsFloor = createVector(
    curbWidth,
    panHeight - trenchFloorThickness - depthDeclineTotal,
  );

  // Floor meet drain left
  const floorMeetsDrainLeft = createVector(
    drainX - (drainPlateWidth / 2),
    panHeight - trenchFloorThickness,
  );


  // Floor meets drain right
  const floorMeetsDrainRight = createVector(
    drainX + (drainPlateWidth / 2),
    panHeight - trenchFloorThickness,
  );

  // Floor meets right wall
  const floorMeetsRightWall = createVector(
    panWidth - splashWallWidth,
    panHeight - trenchFloorThickness - depthDeclineTotal,
  );

  const rightFloorAngle = getAngle(
    p5, floorMeetsDrainRight, floorMeetsRightWall,
  );

  const leftFloorAngle = getAngle(
    p5, leftWallMeetsFloor, floorMeetsDrainLeft,
  );

  let leftWallAdjust = 0;
  let rightWallAdjust = 0;

  const angleDelta = Math.abs(leftFloorAngle - rightFloorAngle);
  let adjustmentPercentage = +((angleDelta / 10).toFixed(2));
  if (adjustmentPercentage > 1) adjustmentPercentage = 1;


  if (angleDelta > 2) {
    if (leftFloorAngle > rightFloorAngle) {
      leftWallAdjust = Math.ceil((floorMeetsDrainLeft.y - leftWallMeetsFloor.y) * adjustmentPercentage);
    } else {
      rightWallAdjust = Math.ceil((floorMeetsDrainRight.y - floorMeetsRightWall.y) * adjustmentPercentage);
    }
  }

  const grateWidthInches = this._getTrenchSize(this.state.panWidthInches - this.state.splashWallWidthInches - this.state.curbWidthInches);
  const floorOutsideTrench = panWidth - splashWallWidth - curbWidth - Math.round(grateWidthInches * scale);

  panFront.beginShape();
  panFront.vertex(0, panHeight - curbHeight);
  panFront.vertex(curbWidth, panHeight - curbHeight);
  panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + leftWallAdjust);

  if (drainPosition === 'Back') {
    panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(leftWallMeetsFloor.x + floorOutsideTrench / 2, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(leftWallMeetsFloor.x + floorOutsideTrench / 2, floorMeetsDrainLeft.y + grateThickness);
    panFront.vertex(floorMeetsDrainLeft.x, floorMeetsDrainLeft.y + grateThickness);
  } else {
    panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + leftWallAdjust);
    panFront.vertex(floorMeetsDrainLeft.x, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(floorMeetsDrainLeft.x, floorMeetsDrainLeft.y + grateThickness);
  }


  if (drainPosition === 'Back') {
    panFront.vertex(floorMeetsRightWall.x - floorOutsideTrench / 2, floorMeetsDrainRight.y + grateThickness);
    panFront.vertex(floorMeetsRightWall.x - floorOutsideTrench / 2, floorMeetsRightWall.y + depthDeclineTotal);
    panFront.vertex(floorMeetsRightWall.x, floorMeetsRightWall.y + depthDeclineTotal);
  } else {
    panFront.vertex(floorMeetsDrainRight.x, floorMeetsDrainRight.y + grateThickness);
    panFront.vertex(floorMeetsDrainRight.x, floorMeetsRightWall.y + depthDeclineTotal);
    panFront.vertex(floorMeetsRightWall.x, floorMeetsRightWall.y + rightWallAdjust);
  }


  panFront.vertex(panWidth - splashWallWidth, 0);
  panFront.vertex(panWidth, 0);
  panFront.vertex(panWidth, panHeight);
  panFront.vertex(0, panHeight);
  panFront.vertex(0, 0);
  panFront.endShape();

  this._cutCompressionDrainPocket(panFront, {
    axis: 'front',
    center: drainX,
    surface: floorMeetsDrainLeft.y + grateThickness,
    bottom: panHeight,
    depth: vars.drainHeight,
    panVariant: 'trench',
    trenchSection: drainPosition === 'Back' ? 'along' : 'cross',
  });

  textSize(14);

  // Pan Width
  this._createMeasureLine(
    curbWidth, -(panLineMargin + vLine - 5),
    panWidth - splashWallWidth, -(panLineMargin + vLine - 5),
    this.state.panWidthInches - this.state.curbWidthInches - this.state.splashWallWidthInches,
  );

  // Curb Width
  this._createMeasureLine(
    0,
    -(panLineMargin + vLine - 5),
    curbWidth - 1,
    -(panLineMargin + vLine - 5),
  );

  // Drain Width
  this._createMeasureLine(
    drainX - (drainDimensionWidth / 2) - 1, panHeight + vLine + 5,
    drainX + (drainDimensionWidth / 2) + 1, panHeight + vLine + 5,
  );

  // Splash Wall Height
  this._createMeasureLine(
    panWidth + sectionDimensionOffset - 5, 0,
    panWidth + sectionDimensionOffset - 5, panHeight,
    panBaseSpec.height,
  );

  // Curb Height
  this._createMeasureLine(
    -(panLineMargin + vLine - 5),
    panHeight - curbHeight,
    -(panLineMargin + vLine - 5),
    panHeight,
    this.state.curbHeightInches,
  );

  // Left curb Wall Width
  line(
    -10,
    -(panLineMargin + vLine - 5),
    0,
    -(panLineMargin + vLine - 5),
  );

  // Right Splash Wall Width
  this._createArrow(
    panWidth + 5,
    -(panLineMargin + vLine - 5),
    'left',
    5,
  );

  // Splash wall amounts
  this._createText(
    this.state.curbWidthInches,
    -28, -(panLineMargin + vLine - 10),
  );

  textSize(14);

  this._createText(
    this.state.splashWallWidthInches,
    panWidth + 25, -(panLineMargin + vLine - 10),
  );

  textSize(12);

  text(
    toleranceRange,
    -50, -(panLineMargin + vLine -25),
  );

  image(panFront, -(padding), -(padding));

  const drainGraphic = this._createTrenchDrain({
    ...vars, vLine,
  });

  image(
    drainGraphic,
    (drainX - (drainWidth / 2) - 10),
    (panHeight - trenchFloorThickness + grateThickness) - 13,
  );

  this._createText(
    drainOpening,
    drainX + drainWidth + 12,
    panHeight + vLine + 10,
  );

  stroke('black');
  strokeWeight(1);

  // Drain Width Pointer
  line(
    drainX + (drainDimensionWidth / 2) - 1, panHeight + vLine + 5,
    drainX + (drainDimensionWidth / 2) + 10, panHeight + vLine + 5,
  );

  // Splash Wall Width - LEFT
  line(0, -(panLineMargin), 0, -(panLineMargin + vLine));
  line(curbWidth, -(panLineMargin), curbWidth, -(panLineMargin + vLine));

  // Splash Wall Width - RIGHT
  line(panWidth, -(panLineMargin), panWidth, -(panLineMargin + vLine));
  line(panWidth - splashWallWidth, -(panLineMargin), panWidth - splashWallWidth, -(panLineMargin + vLine));

  // Pan Height
  line(
    panWidth + panLineMargin, 0,
    panWidth + sectionDimensionOffset, 0,
  );

  line(
    panWidth + panLineMargin, panHeight,
    panWidth + sectionDimensionOffset, panHeight,
  );

  // Curb Height
  line(
    -(panLineMargin + vLine), panHeight - curbHeight,
    -(panLineMargin), panHeight - curbHeight
  );

  line(
    -(panLineMargin + vLine), panHeight,
    -(panLineMargin), panHeight
  );


  // Back Splash Wall Line
  line(
    0, 0,
    panWidth, 0,
  );

  // Trench Grate Line
  if (drainPosition === 'Back') {
    line(
      curbWidth, panHeight - trenchFloorThickness,
      panWidth - splashWallWidth, panHeight - trenchFloorThickness,
    );
  } else {
    line(
      floorMeetsDrainLeft.x, panHeight - trenchFloorThickness,
      floorMeetsDrainRight.x, panHeight - trenchFloorThickness,
    );
  }

  noStroke();
  textSize(20);

  text(
    'SECTION A-A',
    (panWidth / 2) - (this._getTextWidth('SECTION A-A') / 2),
    120,
  );
}
